export default __webpack_public_path__ + "static/media/rakhi5.f82939c1.jpeg";